import React, { FC } from 'react'
import { Button, Select } from '@pepper/ui'

import styles from './_.module.css'

interface IProps {
  setTempCountry: (val: string) => void
  tempCountry: string
  updateCountry: (val: string) => void
  timezones?: Timezone[]
  loadingCountry: boolean
}

const CollectCountry: FC<IProps> = ({
  setTempCountry,
  tempCountry,
  updateCountry,
  timezones,
  loadingCountry,
}) => {
  return (
    <div className={styles.wrapCompany}>
      <div className={styles.countrySelectLabel}>
        Choose your <b>billing country</b>
      </div>
      <Select
        className={styles.countryInput}
        onChange={val => setTempCountry(val)}
        size="large"
        showSearch={true}
        optionFilterProp="label"
        options={timezones?.map(timeCountry => ({
          label: timeCountry.country_name,
          value: timeCountry.country_code,
        }))}
      />
      <section>
        <Button
          disabled={tempCountry === ''}
          className={styles.nextBtn}
          type="primary"
          loading={loadingCountry}
          htmlType="submit"
          onClick={() => updateCountry(tempCountry)}
        >
          Confirm
        </Button>
      </section>

      {tempCountry === '' && (
        <div className={styles.note}>
          <p>
            <b>Note :</b> Please select your billing country to proceed
          </p>
        </div>
      )}

      {tempCountry === 'IN' && (
        <div className={styles.note}>
          <p>
            <b>Note :</b> All orders associated to this billing country will be
            invoiced in INR. Please note that once you complete this step, you
            will not be able to change your billing country.
          </p>
        </div>
      )}

      {tempCountry !== '' && tempCountry !== 'IN' && (
        <div className={styles.note}>
          <p>
            <b>Note :</b> All orders associated to this billing country will be
            invoiced in USD. Please note that once you complete this step, you
            will not be able to change your billing country.
          </p>
        </div>
      )}
    </div>
  )
}

export default CollectCountry
